import { RootState } from '~/store';

export const bookModerationSelector = (state: RootState) => state.bookModeration;
